import { useCallback, useMemo } from "react";
import { getVariables, Variable } from "src/types/messages/variables";
import { Settings } from "../context/SettingsContext/settings";

const VariablesRegex = new RegExp("({{(.*))");
const ExactVariablesRegex = new RegExp("({{(.+?)}})");

export function $isVariable(text: string): boolean {
  return ExactVariablesRegex.test(text);
}

export function $matchVariable(text: string, exact: boolean) {
  return exact ? ExactVariablesRegex.exec(text) : VariablesRegex.exec(text);
}

export function useVariables({
  enableVariables,
  variablesContext,
}: Partial<Settings>) {
  const variables = useMemo(
    () => (enableVariables ? getVariables(variablesContext) : []),
    [enableVariables, variablesContext]
  );

  const search = useCallback(
    (string: string, callback: (results: Array<Variable>) => void): void => {
      setTimeout(() => {
        const results =
          string.length === 0
            ? variables
            : variables.filter((variable) =>
                variable.key.toLowerCase().includes(string.toLowerCase())
              );
        callback(results);
      }, 500);
    },
    [variables]
  );

  const isValid = useCallback(
    (key: string): boolean => {
      return variables.some((variable) => {
        return variable.key === key || `{{${variable.key}}}` === key;
      });
    },
    [variables]
  );

  return { search, isValid };
}
